// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pdpProductPriceAndActionsStyle } from "@ces/App/Components/Product/PdpProductPriceAndActions";
import { VERY_SMALL_SCREEN_WIDTH } from "@ces/XDL/constants";
import { color, hideElementOnPrint, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

pdpProductPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            border: none;
            padding: 0;
            max-width: none;
        `,
    },
    addToList: {
        css: css`
            justify-content: end;
        `,
    },
    qtyInfo: {
        css: css`
            flex-direction: column;
            gap: 8px;
            ${xScreen("lte", "sm")} {
                margin-bottom: 8px;
            }
        `,
    },
    price: {
        css: css`
            margin: 0;
        `,
    },
    availability: {
        css: css`
            margin-bottom: 4px;
        `,
    },
};

pdpProductPriceAndActionsStyle.pdpLoginMsg = {
    size: 14,
    lineHeight: "22px",
    css: css`
        padding: 12px;
        border-radius: 2px;
        background-color: ${color("common.ui11")};
        width: 100%;
        margin-bottom: 4px;
        display: block;
        &&&& {
            a,
            a span {
                font-size: 14px;
                line-height: 22px;
                color: ${color("secondary")};
                &:not([disabled]):hover,
                &:not([disabled]):focus {
                    color: ${color("common.ui9")};
                }
            }
        }
        @media print {
            display: none;
        }
    `,
};

pdpProductPriceAndActionsStyle.productPrice = {
    wrapper: {
        css: css`
            width: 100%;
            margin-bottom: 8px;
        `,
    },
    price: {
        priceText: {
            variant: "h3",
            forwardAs: "p",
            css: css`
                margin: 0;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 14,
                lineHeight: "22px",
            },
        },
    },
};

pdpProductPriceAndActionsStyle.divider = {
    css: css`
        border-top: 1px solid ${color("common.border")};
        margin: 8px 0;
        width: 100%;

        ${hideElementOnPrint}
    `,
};

pdpProductPriceAndActionsStyle.productAvailabilityStyles = {
    messageGridItem: {
        width: 6,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 6,
    },
    availabilityByWarehouseLink: {
        css: css`
            ${xScreen("lte", "md")} {
                margin-left: auto;
            }
        `,
    },
};

pdpProductPriceAndActionsStyle.productActionsLargeScreenFullActions = {
    productAddToCartButtonStyles: {
        css: css`
            ${xScreen("gt", "md")} {
                white-space: nowrap;
                max-width: 76px;
            }
        `,
    },
    productUnitOfMeasureSelectStyles: {
        css: css`
            ${xScreen("gt", "md")} {
                width: 80px;
                min-width: 80px;
            }

            ${xScreen("lte", VERY_SMALL_SCREEN_WIDTH)} {
                width: 100%;
            }
        `,
        cssOverrides: {
            formField: css`
                ${xScreen("gt", "md")} {
                    min-width: 80px;
                    max-width: 80px;
                }

                ${xScreen("lte", VERY_SMALL_SCREEN_WIDTH)} {
                    max-width: 100%;
                }
            `,
        },
    },
    productQuantityOrderedStyles: {
        wrapper: {
            css: css`
                ${xScreen("gt", "md")} {
                    width: 112px;
                    min-width: 112px;
                }

                ${xScreen("lte", VERY_SMALL_SCREEN_WIDTH)} {
                    width: 100%;
                }
            `,
        },
    },
    qtyWrapper: {
        css: css`
            ${xScreen("lte", VERY_SMALL_SCREEN_WIDTH)} {
                width: calc(50% - 4px);
            }
        `,
    },
    productUomWrapper: {
        css: css`
            ${xScreen("lte", VERY_SMALL_SCREEN_WIDTH)} {
                width: calc(50% - 4px);
            }
        `,
    },
};
